import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  dropdownContainerWrapper: {
    position: 'relative',
  },
  dropdownContainer: {
    position: 'absolute',
    width: '100%',
    zIndex: 1,
    maxHeight: '200px',
    overflow: 'auto'
  },
  suggestionItemActive: {
    background: `${theme.palette.background.default} 0% 0% no-repeat padding-box`,
    cursor: 'pointer',
    padding: '5px 20px',
  },
  suggestionItem: {
    backgroundColor: theme.palette.common.white,
    cursor: 'pointer',
    padding: '5px 20px',
    color: theme.palette.common.black
  }
}));
